import quantum from '../elements/quantum.js';
quantum.register();
